import { SafeHtml } from '@angular/platform-browser';

import { TestObject } from './testObject';
import { Property } from './property';
import { Version } from './version';
import { UF } from './uf';
import { ProductProperty } from './productProperty';
import { ECU } from './ecu';
import { OffboardComponent } from './offboardComponent';
import { TestAnalysisVersionResult } from './testAnalysis';

export class TestCase {
	public tcUid: string;

	public itemNo: string;

	public description: string;

	public descriptionSafeHtml: SafeHtml;

	public version: number;

	public versions: Version;

	public ufs: UF[];

	public productProperties: ProductProperty[];

	public ecus: ECU[];

	public offboardComponents: OffboardComponent[];

	public regTime: Date; // Creation time

	public regBy: string;

	public name: string;

	public requirement: string;

	public inputTypeId: number;

	public script: string;

	public resultCount: number;

	public owners: string[];

	public operator: string;

	public value: string; //value for operator used in conditional linking

	public parentUid: string;

	public testCases: TestCase[];
}

export class TestCaseWithResults {
	public testCaseUid: string;

	public testCaseName: string;

	public results: TestAnalysisVersionResult[];

	public highestVersion: number;
}

export class TestCaseAlternative {
	public uid: string;

	public version: number;

	public name: string;

	public label: string;

	public fromDate: Date;

	public toDate: Date;

	public validFromSop: string;

	public validToSop: string;

	public testObject: TestObject;

	public regBy: string;

	public regTime: Date;

	public properties: Property[];

	public testGroups: string[];
}
